// app/javascript/modules/ferias/form_initial_state.js
// Aplica o estado inicial do formulário de férias.
// Em modo criação: esconde períodos 2/3 e dias_vendidos.
// Em modo edição: mantém visíveis os períodos que já têm valores.

export function initFeriasInitialState(form) {
  function hasValue(...selectors) {
    return selectors.some(sel => (form.querySelector(sel)?.value || '').trim() !== '')
  }

  function apply() {
    const periodo2 = form.querySelector('[data-ferias-periodo="2"]')
    const periodo3 = form.querySelector('[data-ferias-periodo="3"]')
    const diasVendidos = form.querySelector('[data-ferias-field="dias_vendidos"]')

    // Mantém visível se já há datas salvas (modo edição)
    if (periodo2 && !hasValue('#params_inicio_ferias_2', '#params_termino_ferias_2')) {
      periodo2.classList.add('hidden')
    }
    if (periodo3 && !hasValue('#params_inicio_ferias_3', '#params_termino_ferias_3')) {
      periodo3.classList.add('hidden')
    }
    // Dias vendidos: controlado pelo form_abono — aqui apenas garante estado inicial
    const abonoCb = form.querySelector('#params_abono_pecuniario')
    if (diasVendidos && !abonoCb?.checked) {
      diasVendidos.classList.add('hidden')
    }
  }

  apply()
  return { destroy() {} }
}
